import { render, staticRenderFns } from "./MegaMenuLevel1.vue?vue&type=template&id=4f3c40a6&"
import script from "./MegaMenuLevel1.vue?vue&type=script&lang=js&"
export * from "./MegaMenuLevel1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports